import React from "react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { getRouteLocalizationNamespaces } from "../../methods/getRouteLocalizationNamespaces";

import HowVahakHelpYou from "../../components/service-pages/how-vahak-help-you/HowVahakHelpYou";
import { getHowVahakHelpsPageLayout } from "components/service-pages/constants/company-pages-methods";

export default function HowVahakHelpMob() {
    return <HowVahakHelpYou />;
}

HowVahakHelpMob.getLayout = getHowVahakHelpsPageLayout;

export async function getStaticProps({ locale }: any) {
    return {
        props: {
            isMobile: false,
            ...(await serverSideTranslations(locale, getRouteLocalizationNamespaces("howVahakHelpYou")))
        }
    };
}
